// import TickIcon from "@src/app/assets/icons/tick.svg?react";
// import viewportState from "@src/app/stores/viewport";
import iconTick from "@src/app/assets/images/icon-tick.svg";
import useWindowDimensions from "@src/app/hooks/useWindowDimensions";
import cx from "classnames";
import { useEffect, useState } from "react";

import styles from "./ShareButtons.module.css";

// Toast Controller
type ToastPayload = {
  title: string;
  visible: boolean;
  isFallback?: boolean;
};

const listeners = new Set<(p: ToastPayload) => void>();

const toastController = {
  show(payload: Omit<ToastPayload, "visible">) {
    listeners.forEach((l) => {
      l({ ...payload, visible: true, isFallback: false });
    });
  },

  hide() {
    listeners.forEach((l) => {
      l({ title: "", visible: false, isFallback: false });
    });
  },

  subscribe(callback: (p: ToastPayload) => void) {
    listeners.add(callback);
    return () => listeners.delete(callback);
  },
};

// Toast Component
export function ShareToastContainer() {
  const { isMobile } = useWindowDimensions();
  const [toast, setToast] = useState<ToastPayload>({
    title: "",
    visible: false,
    isFallback: false,
  });

  useEffect(() => {
    const unsubscribe = toastController.subscribe((data) => {
      setToast(data);
    });
    return () => {
      unsubscribe();
    };
  }, []);

  if (!toast.visible) return null;

  return (
    <div
      style={
        isMobile
          ? {
              bottom: `calc(env(safe-area-inset-bottom) + 20px)`,
              left: "20px",
              right: "20px",
              marginLeft: "auto",
              marginRight: "auto",
            }
          : {
              bottom: `calc(env(safe-area-inset-bottom) + 20px)`,
              left: "20px",
              width: "319px",
            }
      }
      className={cx(styles.shareToast)}
    >
      {!toast.isFallback && (
        <img className={styles.icon} src={iconTick} alt="tick" />
      )}
      <span>{toast.title}</span>
    </div>
  );
}

// Native Share Function
export function nativeShare({
  title,
  text,
  url,
  toastTitle,
  fallbackToastTitle,
  autoClose = 3000,
}: {
  title: string;
  text: string;
  url: string;
  toastTitle: string;
  fallbackToastTitle: string;
  autoClose?: number;
}) {
  // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
  if (window.navigator && window.navigator.share) {
    void window.navigator.share({ title, text, url }).then(() => {
      toastController.show({
        title: toastTitle,
      });

      setTimeout(() => {
        toastController.hide();
      }, autoClose);
    });
  } else {
    // fallback to copy to clipboard
    void window.navigator.clipboard.writeText(url).then(() => {
      toastController.show({
        title: fallbackToastTitle,
        isFallback: true,
      });

      setTimeout(() => {
        toastController.hide();
      }, autoClose);
    });
  }
}
